import { store } from '@whelk/store';
import { setBannedAppealModal } from '@whelk/store/slices/userSlice';
export const openBannedAppealModal = (message: string) => {
  store.dispatch(setBannedAppealModal({ show: true, message: message }));
};
